import React from "react";
import NavbarWithCTAButton from "../Nav";
import SideBar from "../Sidebar";
import { useDashboardShell } from "../../hooks/useDashboardShell";

export default function DashboardLayout({
  children,
  active,
  className = "",
  contentClassName = "",
  animation,
}) {
  const {
    isSidebarOpen,
    isSidebarCollapsed,
    toggleSidebar,
    closeSidebar,
    toggleSidebarCollapse,
  } = useDashboardShell();
  const sidebarWidth = isSidebarCollapsed ? "4rem" : "18rem";

  return (
    <div
      className={`dashboard-shell min-h-screen bg-gray-50 dark:bg-gray-900 ${className}`}
      style={{ "--dashboard-sidebar-width": sidebarWidth }}
    >
      <SideBar
        active={active}
        isSidebarOpen={isSidebarOpen}
        isCollapsed={isSidebarCollapsed}
        closeSidebar={closeSidebar}
        toggleCollapse={toggleSidebarCollapse}
      />

      <div className="dashboard-shell__content">
        <NavbarWithCTAButton
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
        />

        <main
          className={`p-4 sm:p-6 ${contentClassName}`}
          data-aos={animation}
        >
          {children}
        </main>
      </div>
    </div>
  );
}
